﻿import $ from 'jquery';
import 'slick-carousel';

class CarCustomiserItem {
    constructor(el, index) {
        this.render(el, index);
        window.window_Customiser = this;
    }

    summaryButtom__CLICK(e) {
        e.preventDefault();
        this.modals.open(CustomiserModals.TYPES.summary);

    }

    placeDeposit__CLICK(e) {
        var url = this.placeDepositButton.data('base-url') || "";
        var params = $.param({ 'modelcode': this.variants.getCurrent().modelCode, 'wid': this.wheels.getCurrent().id, 'cid': this.colors.getCurrent().id });
        
        location.href = url + "?" + params;
    }

    servicePlanButton__CLICK(e) {
        var url = this.servicePlanButton.data('base-url') || "";
        var params = $.param({ 'modelcode': this.variants.getCurrent().modelCode });

        location.href = url + "?" + params;
    }

    carForSaleButton__CLICK(e) {
        e.preventDefault();
        var carSaleSection = $('#similar-car-tiles');
        $('body,html').animate({
            scrollTop: $(carSaleSection).offset().top
            },
        800);
    }

    brochureButton__CLICK(e) {
        e.preventDefault();
        //open popup.
        this.modals.open(CustomiserModals.TYPES.brochure);
    }

    financeButton__CLICK(e) {
        e.preventDefault();
        var target = $(e.currentTarget);
        var params = $.param({ 'modelcode': this.variants.getCurrent().modelCode })
        location.href = (target.data('base-url') + "?" + params);
    }

    changeModelButton__CLICK(e) {
        e.preventDefault();
        this.customiserPicker.show(); 
    }

    getModel__SEND(modelName) {
        var _url = '/app/nz/api/customiser/get';

        return $.ajax({
            type: 'GET',

            url: _url,
            data: {
                "name": modelName
            },
            success: this.getModel__SUCCESS.bind(this),
            error: function (response) {
                console.log(response);
            }
        });
    }

    getModel__SUCCESS(data) {      
        this.modelData = data;
        this.variants.setVariants(this.modelData, this.modelData[0].hidePrice, this.modelData[0].formOverride);
        this.setVariant(this.modelData[0].variantName, this.modelData[0].hidePrice, this.modelData[0].formOverride);

        if (this.modelData[0].formOverride) {
            this.updateFormOverrideButtons(this.modelData[0].formOverride.name, this.modelData[0].formOverride.url);
        }
        else {
            this.updateFormOverrideButtons('','');
        }
    }

    getImages__SEND() {
        var _url = '/app/nz/api/customiser/getimages';

        var _request = {
            modelName: this.currentSelection.model,
            bodyType: this.currentSelection.variant,
            colour: this.currentSelection.color,
            wheel: this.currentSelection.wheel
        };

        return $.ajax({
            type: 'POST',
            url: _url,
            data: _request
        });
    }

    getSuggestionStocks__SEND() {
        var _similarCarSection = $('#similar-car-tiles');
        var carForSaleButton = $('[data-component="car-for-sale-button"]');

        if (_similarCarSection.length > 0) {
            var _request = {
                modelName: this.currentSelection.model,
                variant: this.currentSelection.variant,
                variantCode: this.currentSelection.variantCode,
                colour: this.currentSelection.color,
                maxSimilarStocks: 4
            };            

            $.ajax({
                type: 'POST',
                url: '/app/nz/api/stockfinder/checksimilarstockdata',
                data: _request,
                success: function (data) {                    
                    if (data > 0) {
                        carForSaleButton.show();
                        return $.ajax({
                            type: 'POST',
                            url: '/app/nz/api/stockfinder/getsimilarstocks',
                            data: _request,
                            success: function (data) {
                                $('#similar-car-tiles').html(data);
                            },
                            error: function (response) {
                                console.log(response);
                            }
                        });
                    }
                    else {
                        carForSaleButton.hide();
                    }
                },
                error: function (response) {
                    console.log(response);
                }
            });            
            
        }
        else {
            return null;
        }
    }

    getVariantByName(variantName) {
        var result = this.modelData.filter(element => element.variantName === variantName);
        if (result.length) {
            return result[0];
        }

        return null;
    }


    changeModel__CLICK(e) {

        var model = $(e.currentTarget).data('model');
        this.changeModel(model);


    }

    changeModel(modelName, _displayName) {
        this.currentSelection = new CustomiserOptions(modelName, _displayName);
        this.getModel__SEND(modelName)
        this.element.trigger('label-change');
        this.element.trigger('model-change');
    }


    model__CHANGED() { }

    variant__CHANGED() { }


    changeVariant__CLICK(e) {
      
        e.preventDefault();
        var target = $(e.currentTarget);
        var variant = target.data('variant');
        this.setVariant(variant, target.data('hideprice'));
        this.variants.setCurrent(target);
        this.element.trigger('label-change')
        //this.element.trigger('variant-change');

        this.updateFormOverrideButtons(target.data('formoverrideText'), target.data('formoverrideLink'));
    }

    updateFormOverrideButtons(text, link) {
        if (text) {
            $('#customiserFormOverrideLink').text(text);
            $('#customiserFormOverrideLink').attr("href", link);
            $('#customiserFormOverrideLink').show();
            $('#customiserStandardFormButton').hide();
        }
        else {
            $('#customiserFormOverrideLink').hide();
            $('#customiserStandardFormButton').show();
        }
    }

    changeColor__CLICK(e) {
       
        e.preventDefault();
        var target = $(e.currentTarget);
        var color = target.data('color');
      
        this.currentSelection.color = color;
        this.updateImagesForCurrentSelection();
        this.element.trigger('label-change');
        this.element.trigger('color-change');
        this.colors.setCurrent(target);

        this.updateSuggestionStocksForCurrentSelection();
    }

    changeWheel__CLICK(e) {
        e.preventDefault();
        var target = $(e.currentTarget)
        var wheel = target.data('wheel');
        this.currentSelection.wheel = wheel;

        this.updateImagesForCurrentSelection();
        this.element.trigger('label-change');
        this.element.trigger('wheel-change');
        this.wheels.setCurrent(target);

    }

    setVariant(variant,hidePrice,formOverride) {
        var c = this.getVariantByName(variant);
 
        this.currentSelection.variant = variant;
        this.currentSelection.color = c.colours[0].colourName;
        this.currentSelection.wheel = c.wheels[0].wheelName;

        if (hidePrice) {
            this.currentSelection.price = 0;
        }
        else {
            this.currentSelection.price = c.mrp;
        }

        this.currentSelection.variantCode = c.modelCode;

        this.updateImagesForCurrentSelection();
        this.wheels.setWheels(c.wheels);
        this.colors.setColors(c.colours);

        this.element.trigger('label-change')
        this.element.trigger('variant-change', c.variantId );

        this.updateSuggestionStocksForCurrentSelection();
    }



    updateImagesForCurrentSelection() {
        var promise = $.Deferred();
      
        this.getImages__SEND().done(function (data) {
            promise.resolve(data)
        })
         
        this.slider.updateSlidesAsync(promise)
    }

    updateSuggestionStocksForCurrentSelection() {
        this.getSuggestionStocks__SEND();
    }

    updateAllLabels() {
        this.selectedColorLabel.text(this.currentSelection.color);
        this.selectedModelLabel.text(this.currentSelection.displayName || "");
        this.selectedVariantLabel.text(this.currentSelection.variant || "");
        this.selectedWheelsLabel.text(this.currentSelection.wheel || "");        

        if (!this.currentSelection.price) {
            this.costLabel.text("TBC");
        }
        else if (this.currentSelection.price && this.currentSelection.price == 0) {
            this.costLabel.text("TBC");
        }
        else if (this.currentSelection.price) {
            var formattedCost = Number(this.currentSelection.price.toFixed(1)).toLocaleString();
      
            this.costLabel.text(formattedCost);
        }
    }

 

    render(el, i) {

        this.currentSelection = new CustomiserOptions();
        this.modelData = {};

        this.element = $(el);
        this.models = this.element.data('models');
        this.slideArea = this.element.find('.c-customiser__preview');
        this.slider = new CarCustomiserSlider(this.slideArea);
        
        this.wheelsArea = this.element.find('.c-customiser__wheels');
        this.wheels = new CustomiserWheels(this.wheelsArea);

        this.extendedDetailsArea = this.element.find('[data-component="c-variant-details"]');
        new ExtendedDetails(this.extendedDetailsArea)

        this.variantsArea = this.element.find('.c-customiser__variants');
        this.variants = new CustomiserVariants(this.variantsArea);

        this.colorsArea = this.element.find('.c-customiser__colors');
        this.colors = new CustomiserColors(this.colorsArea);

        this.modals = new CustomiserModals(this, this.currentSelection);

        this.customiserApp = this.element.find('.c-customiser__app');
 
        this.customiserPicker = new CustomiserPicker(this);

        this.previousUrl = this.element.data('previous-url');

        this.currentModel = this.element.data('init'); //init to a particular car if it is set up.

        if (this.currentModel) {
            this.modelData = this.element.data('init-variants');

            var _defaultVariant = this.element.data('default-variant');
            var _index = this.modelData.findIndex(e => e.variantName == _defaultVariant);

            var _variant = this.modelData[_index].variantName;
            var _wheel = this.modelData[_index].wheels[0].wheelName;
            var _colour = this.modelData[_index].colours[0].colourName;
            var _variantCode = this.modelData[_index].modelCode;
            this.currentSelection = new CustomiserOptions(this.currentModel, this.currentModel, _variant, _wheel, _colour, _variantCode);
                        
            this.currentSelection.price = this.modelData[_index].mrp;
            this.updateSuggestionStocksForCurrentSelection();
            this.customiserPicker.hide();
        }
        else {
            this.customiserPicker.show();

        }

        


        this.selectedModelLabel = this.element.find('[data-component="selected-model"]');
        this.selectedVariantLabel = this.element.find('[data-component="selected-variant"]');
        this.costLabel = this.element.find('[data-component="calculated-cost"]');

        this.selectedWheelsLabel = this.element.find('[data-component="selected-wheel"]');
        this.selectedColorLabel = this.element.find('[data-component="selected-color"]');

        //button events.
        this.changeModelButton = this.element.find('[data-component="change-model"]');
        this.changeModelButton.on('click', this.changeModelButton__CLICK.bind(this));
        this.summaryButton = this.element.find('[data-component="summary-button"]');
        this.summaryButton.on('click', this.summaryButtom__CLICK.bind(this));
        this.brochureButton = this.element.find('[data-component="brochure-download"]');
        this.brochureButton.on('click', this.brochureButton__CLICK.bind(this));
        this.financeButton = this.element.find('[data-component="finance-options"]');
        this.financeButton.on('click', this.financeButton__CLICK.bind(this));
        this.placeDepositButton = this.element.find('[data-ref="place-deposit"]');
        this.placeDepositButton.on('click', this.placeDeposit__CLICK.bind(this));
        this.carForSaleButton = this.element.find('[data-component="car-for-sale-button"]');
        this.carForSaleButton.on('click', this.carForSaleButton__CLICK.bind(this));
        this.servicePlanButton = this.element.find('[data-ref="service-plan-tool"]');
        this.servicePlanButton.on('click', this.servicePlanButton__CLICK.bind(this));

        //delegated events.
        this.element.on('click', '[data-ref="change-variant"]', this.changeVariant__CLICK.bind(this));
        this.element.on('click', '[data-ref="change-model"]', this.changeModel__CLICK.bind(this));
        this.element.on('click', '[data-ref="change-color"]', this.changeColor__CLICK.bind(this));
        this.element.on('click', '[data-ref="change-wheel"]', this.changeWheel__CLICK.bind(this));

        this.element.one('color-change', function () { this.selectedColorLabel.removeClass('c-customiser__detail-line--default') }.bind(this))
            .one('wheel-change', function () { this.selectedWheelsLabel.removeClass('c-customiser__detail-line--default') }.bind(this))
            .one('model-change', function () { this.element.removeClass('c-customiser--cold'); }.bind(this));

        

        this.element.on('label-change', this.updateAllLabels.bind(this));
        $(window)
            .on('model-change', this.model__CHANGED.bind(this))
            .on('variant-change', this.variant__CHANGED.bind(this));

    }
}

class CustomiserOptions {
    constructor(model, displayName, variant, wheel, color, variantCode) {
        this.displayName = displayName;
        this.model = model;
        this.variant = variant;
        this.variantCode = variantCode; 
        this.wheel = wheel;
        this.color = color;
    }
}
class CustomiserWheels {
    constructor(el) {
        this.element = $(el);
        this.current = this.element.children(':first').addClass('c-customiser__wheel--selected');
    }
    getCurrent() {
        return {
            id: this.current.data('id'),
            name: this.current.data('wheel')
        }
    }
    setWheels(wheels) {
        this.element.empty();
        var w = wheels.map(this.render);
        this.element.append(w)
        if (w.length) {
            this.current = w[0].toggleClass('c-customiser__wheel--selected');
        }
    }

    setCurrent(wheel) {
        if (this.current != wheel) {
            this.current.toggleClass('c-customiser__wheel--selected');
            wheel.toggleClass('c-customiser__wheel--selected');
            this.current = wheel;
        }
    }


    render(wheelData) {

        var template = `<a href="#" title="${wheelData.wheelName}" class="c-customiser__wheel ${wheelData.isSpecial ? 'c-customiser__wheel--is-premium' : ''}" data-ref="change-wheel" data-id="${wheelData.wheelId}" data-wheel="${wheelData.wheelName}">
<span style="background-image: url(${wheelData.thumbUrl}&height=76&width=76);" alt="${wheelData.wheelName} preview"></span>
${wheelData.wheelName}
</a>`;
        return $(template)
    }
}

class CustomiserColors {
    constructor(el) {
        this.element = $(el);
        this.current = this.element.children(':first').addClass('c-customiser__color--selected');
        
    }

    getCurrent() {
        return {
            id: this.current.data('id'),
            name: this.current.data('color')
        }
    }

    setColors(colors) {
      
        this.element.empty();
        var colors = colors.map(this.render)
        this.element.append(colors);
        if (colors.length) {
            this.current = colors[0].toggleClass('c-customiser__color--selected');
        }
    }

    setCurrent(color) {
      
        if (this.current != color) {
            //unset the current color, as we are about to change to a different one.
          
            this.current.toggleClass('c-customiser__color--selected');
            color.toggleClass('c-customiser__color--selected');
            this.current = color;
        }
    }

    render(colorData) {
        var template = `<a href="#" class="c-customiser__color ${colorData.isSpecial ? 'c-customiser__color--is-premium' : ''}" title="${colorData.colourName}" data-ref="change-color" data-id="${colorData.colourId}" data-color="${colorData.colourName}">
<span style="background-image: url(${colorData.thumbUrl}?height=60);" alt="${colorData.colourName} preview">
</a>`;
        return $(template)

    }
}


class CustomiserPicker {
    constructor(customiser) {
        this.customiser = customiser;

        this.element = this.customiser.element;
        this.modelPicker = this.element.find('.c-customiser__model-picker');
        this.slider = this.modelPicker.find('[data-slick]');
        this.isShowing = false;
        let next = this.modelPicker.find('.left');
        let prev = this.modelPicker.find('.right')
        let filters = this.modelPicker.find('[data-filter]');
        new ModelSlider(this.slider, prev, next, filters);

        var customiseButtons = this.modelPicker.find('button.choose-model');

        let customiseButton__CLICK = function (e) {
            if (this.isShowing) {

            let model = $(e.currentTarget).val()

            if (model) {
                let displayName = $(e.currentTarget).data('displayName') || model
                this.customiser.changeModel(model, displayName);
                this.hide();
            }
            }
        };

        customiseButtons.on('click', customiseButton__CLICK.bind(this))
      
    }



    show() {
        this.isShowing = true;
        this.modelPicker.removeAttr('hidden')
        this.customiser.customiserApp.stop().fadeOut(200,function () {
            this.modelPicker.stop().fadeIn(200);
            this.slider.slick('refresh');

        }.bind(this))
 
 
    }
    hide() {
        this.isShowing = false;
        this.modelPicker.stop().fadeOut(200, function () {
            this.customiser.customiserApp.stop().fadeIn(200);
            this.customiser.slider.refresh();  
        }.bind(this));

       
    }
}

class CustomiserModals {

    static get TYPES() {
        return {
            summary: 'customiser.modal.summary',
            brochure: 'customiser.modal.brochure',
         //   modelPicker: 'customiser.modal.model-picker'
        }
    }

    constructor(customiser) {
        this.customiser = customiser;

        this.element = customiser.element;
     
        this.summaryForm = this.element.find('.c-customiser__summary-form');
        this.brochureForm = this.element.find('.c-customiser__brochure-form');
       
 
  

        this.modal = this.element.find('.c-customiser__modal');
        this.modalContent = this.modal.find('[data-component="c-customiser-modal-content"]');

        this.modal.on('click', '.close', this.close__CLICK.bind(this));

        this.current;
    }

    open(modalType) {
       
        if (this.current) {
            this.current.detach();
        }

        switch (modalType) {
            case CustomiserModals.TYPES.summary:
                this.current = this.summaryForm;
                this.mapValueToField('.carmodel input:hidden', this.customiser.currentSelection.model);
                this.mapValueToField('.carvariant input:hidden', this.customiser.currentSelection.variant);
                this.mapValueToField('.carwheel input:hidden', this.customiser.currentSelection.wheel);
                this.mapValueToField('.carcolour input:hidden', this.customiser.currentSelection.color);
                var _price = '$' + Number(this.customiser.currentSelection.price.toFixed(1)).toLocaleString();
                this.mapValueToField('.vehicleprice input:hidden', _price);
                this.mapValueToField('.customiserpreviewimage  input:hidden', this.customiser.slider.getImage());
              
                //title element is rendered by umbraco forms.
                var titleEl = $('.title h3', this.summaryForm); //search for title in the summaryform scope.
                if (titleEl.length) {
                    titleEl.text(`My ${this.customiser.currentSelection.model}`);
                }

                break;

            case CustomiserModals.TYPES.brochure:
                this.current = this.brochureForm;


                this.mapValueToField('.carmodel input:hidden', this.customiser.currentSelection.model);

                break;

 

        }
        this.modalContent.append(this.current);
        this.modal.show();
    }


    close__CLICK() {
 
        this.close();
    }

    close() {

       
        this.modal.hide();
    }

    mapValueToField(fieldSelector, value) {
        var field = this.current.find(fieldSelector)
      
        field.val(value);
    }
}

class CustomiserVariants {
    constructor(el) {
        this.element = $(el);
      
        this.current = this.element.find('.c-customiser__variant--selected');

    }

    getCurrent() {
        return {
            modelCode: this.current.data('model-code'),
            name: this.current.data('variant')
        }
    }

    setVariants(variants,hidePrice,formOverride) {
        this.element.empty();
        var v = variants.map(this.render);
        
        for (var i = 0; i < v.length; i++) {
            $(v[i]).attr("data-hideprice", hidePrice);
            if (formOverride) {
                $(v[i]).attr("data-formoverride-link", formOverride.url);
                $(v[i]).attr("data-formoverride-text", formOverride.name);
            }
        }

        this.element.append(v);
        if (v.length) {
            this.current = v[0].toggleClass('c-customiser__variant--selected');
        }
    }


    hasCurrent() {
        return this.current !== null;
    }

    setCurrent(variant) {
        
        if (this.hasCurrent() && this.current !== variant) {
            this.current.toggleClass('c-customiser__variant--selected');
        }
        variant.toggleClass('c-customiser__variant--selected');
        this.current = variant;
    }

    render(carVariant) {
        return $("<a/>", { 'href': "#", 'class': 'c-customiser__variant',  'text': carVariant.variantName, 'data-model-code':carVariant.modelCode,'data-ref': 'change-variant', 'data-variant': carVariant.variantName });
    }
}

class ModelSlider {
    constructor(slider, next,prev, filter) {
        this.filter = $(filter);
        console.log(this.filter)
        this.element = $(slider);
        if (filter.length) {
            filter.on('click', function (e) {
                var type = $(e.currentTarget).data('filter');
                this.element.slick('slickUnfilter');
                filter.removeClass('active');
                $(e.currentTarget).addClass('active')
                this.element.slick('slickFilter', `[data-filter-key='${type}']`)
            }.bind(this))
        }

        let responsive = [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,

                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }

        ];
        this.element.slick({ prevArrow: prev, nextArrow: next, responsive });
    }

 

}

class CarCustomiserSlider {
    constructor(el) {
        this.element = $(el);
        this.spinner = new Spinner().element.hide();
        this.element.append(this.spinner)
        this.slickSlider = this.element.find('[data-component="slider"]');
        this.slickControls = this.element.find('[data-component="slider-nav"]');
        this.slickButtons = this.element.find('[data-component="slider-nav"]');//this.element.find('[data-component="slider-canvas"]');
        this.urlParams = 'width=1000&height=455&bgcolor=fff&mode=crop';
        this.currentPromise = null;
        this.settings = {
            dots: true,
            infinite: true,
            speed: 100,
            fade: true,
            cssEase: 'linear',
            appendArrows: this.slickButtons,
            appendDots: this.slickControls
        }
        this.slickSlider.slick(this.settings);
        this.slickSlider.on('destroy', this.setLoading.bind(this));
        this.slickSlider.on('init', this.loadingComplete.bind(this));
        this.slickSlider.on('reInit', this.loadingComplete.bind(this));
    }

    setLoading() {
        this.spinner.stop();
        this.spinner.fadeIn();
    }
    loadingComplete() {
        this.spinner.stop();
        this.spinner.fadeOut();
    }
    updateSlides(slides) {

        this.clearOldSlides();
        this.addNewSlides(slides);
    }

    refresh() {
        this.slickSlider.slick('setPosition');
    }

    clearOldSlides() {
        //save the current index so we can move back to the same angle image.
        var currentSlide = this.slickSlider.slick('slickCurrentSlide');

        //extend settings with the saved value - first param is the object to change, and second will be merged in.
        $.extend(this.settings, { initialSlide: currentSlide });
        this.slickSlider.slick('unslick');
        this.slickSlider.empty();//remove all children;
    }

    addNewSlides(slides) {
        
        for (var i = 0; i < slides.length; i++) {
            this.slickSlider.append(this.makeSlide(slides[i]));
        }
        if (this.settings.initialSlide >= slides.length) {
            this.settings.initialSlide = 0;
        }
        this.slickSlider.slick(this.settings);
    }


    updateSlidesAsync(promise) {

      
        if (this.currentPromise != null && this.currentPromise.state() === "pending") {
           //reject due to new promise being initiated
            this.currentPromise.reject();
        }
        else {
            this.clearOldSlides();
        }
        this.currentPromise = promise.done(this.addNewSlides.bind(this));
    }

    getImage(index) {
        var images = this.slickSlider.find('img');
        var index = index || 0;
        if (images.length && images.length > index) {
            return this.slickSlider.find('img').eq(index).attr('src');
        }
        return "";
    }

    makeSlide(slide) {
        var template = `<picture>
  <source srcset="${slide["imageUrl"]}?format=webp&${this.urlParams}&timestamp=${slide["timestamp"]}" type="image/webp">
  <source srcset="${slide["imageUrl"]}?format=jpg&${this.urlParams}&timestamp=${slide["timestamp"]}" type="image/jpeg"> 
  <img src="${slide["imageUrl"]}?format=jpg&${this.urlParams}&timestamp=${slide["timestamp"]}" alt="${slide["alt"]}">
</picture>
`
        return $(template);
    }
}


class Spinner {
    constructor() {
        var template = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" viewBox="0 0 24 24" class="StyledSpinner" style="display:none">
                    <path d="M12,5a7,7 0 1,0 0,14a7,7 0 1,0 0,-14" class="BackgroundPath"></path>
                    <path d="M12,5a7,7 0 1,0 0,14a7,7 0 1,0 0,-14" class="ForegroundPath"></path>
                </svg>`

        this.element = $(template);
    }


}

class ExtendedDetails {
    constructor(el) {
        this.element = $(el);
        this.content = this.element.find('[data-component="c-variant-content"]');
        this.spinner = new Spinner().element.hide();
        this.element.append(this.spinner);
        if (this.content.children().length === 0) {
            this.element.hide();            
        }       

        $(window).on('model-change', this.model__CHANGED.bind(this))
            .on('variant-change', this.variant__CHANGED.bind(this));
   
    }

    getData(id) {
        this.showSpinner();
        this.content.hide();
        var _url = '/app/nz/api/customiser/getextendeddetails';
        var _request = {
            id: id
        };

        return $.ajax({
            type: 'GET',
            url: _url,
            data: _request,
            success: this.data__SUCCESS.bind(this)
        });
    }

    data__SUCCESS(data) {
        this.hideSpinner();
        if (data) {        

            this.content.html(data);
            this.element.show();
            this.content.fadeIn();

            return;
        }
        this.element.hide(); //no variant data for now.
        
    }

    showSpinner() {
        this.spinner.fadeIn();
    }

    hideSpinner() {
        this.spinner.fadeOut();

    }

    model__CHANGED() {
        this.element.hide();
    }
    variant__CHANGED(event, id) {
        
        this.getData(id)
    }



}

class CarCustomiser {
    constructor(selector, element) {
        this.all = element.querySelectorAll(selector);
        for (var i = 0; i < this.all.length; i++) {
            this.render(this.all[i], i);
        }
    }

    static get EVENT() {
        return {
            ModelChanged: 'CarCustomiser.EVENT.model-changed',
            VariantChanged: 'CarCustomiser.EVENT.variant-changed',
        }
    }

    render(el, index) {
        new CarCustomiserItem(el, index);
    }
}

export default CarCustomiser;